import MoveCanvas from './MoveCanvas';

export default {
  __init__: [ 'moveCanvas' ],
  moveCanvas: [ 'type', MoveCanvas ]
};